import $api from '../services';

export default {
    uploadImage(param) {
        //TODO: change to email
        return $api.post('/sessions/photo', param);
    }
};
